import TableTab3 from "./TableTab3";
import ActivityCard from '../../../../Core/Activity/ActivityCard';
const Tab3 = ({ItemGroupName, setselected_tax_item_data, selected_tax_item_data }) => {

  return (

     <div>
      <div className="px-4" style={{ background: 'white' }}>
   <div className="mb-3" style={{ display: 'flex', gap: '20px',border: '1px solid #DBDBDB', borderRadius: '5px' }} >

            <div className="col-md-12">
              <div className='' style={{height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
 <div style={{ display: 'flex', gap: '15px'}}>
                <div style={{ flex: 1 }}>
                  <p className='' style={{ fontSize: '16px', fontWeight: '600' }}>Item Tax</p>
                </div>
              </div>

                <TableTab3 setselected_tax_item_data={setselected_tax_item_data} selected_tax_item_data={selected_tax_item_data} />




              </div>
            </div>

          </div>
            <div className="mb-3" style={{ display: 'flex', gap: '20px' }} >

          <div className="col-md-12">
            <div className='' style={{ height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
             <ActivityCard doctype={'Item Group'} docname={'Ban'} />
            </div>
          </div>
        </div>
          </div>
          </div>

   
  )
}

export default Tab3